import styled from 'styled-components';

import { BREAK_POINTS } from '../../consts/styleDedupe';
import { COLOURS } from '../../consts/style';

export const ContentContainer = styled.div`
  padding: 24px;
  @media screen and (min-width: ${BREAK_POINTS.Min.LG}) {
    padding: 32px;
  }
`;

export const CardLinkContainer = styled.div`
  background: white;
  cursor: pointer;
  [data-id*='card'] {
    text-decoration: none;
  }

  [data-id='link'] {
    text-decoration: none;
    display: inline;
    width: auto;
    padding: 12px 8px;
    font-weight: 600; 
    color: ${COLOURS.PRIMARY.RED};
    margin: -12px 0 0 -8px;
  }

  &:hover {
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.16);

    [data-id='fixed-aspect-image'] {
      transform: scale(1.1);
      transition: transform 0.5s ease-out;
    }
    & [data-id='link'] {
        background-color: ${COLOURS.PRIMARY.RED_LIGHT};
      }
    }
  }
`;

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  margin-top: 0;
  color: ${COLOURS.TEXT.HEADING};
`;

export const Stack = styled.div`
  & > *:not(:last-child) {
    margin-bottom: 16px !important;

    @media screen and (min-width: ${BREAK_POINTS.Min.LG}) {
      margin-bottom: 24px !important;
    }
  }
`;

export const Content = styled.div`
  img {
    height: 72px;
    margin-bottom: 24px;
  }
  @media screen and (min-width: ${BREAK_POINTS.Min.LG}) {
    display: flex;
    & > *:first-child {
      flex: 1;
      order: 1;
    }
    img {
      height: 96px;
      order: 2;
      margin-left: 32px;
    }
  }

  [data-id='text'] {
    word-break: normal;
    hyphens: unset;
  }
`;
